
import axios from "axios";

// Deployment flag - change only this line when deploying
export const USE_LIVE_API =true; // Set to false for test/staging

// Dynamic base URL based on the flag
export const baseURL = USE_LIVE_API
  ? "https://api.datalumio.co"
  : "https://test.datalumio.co";

// Optional: Keep old URLs commented for reference
// export const baseURL = "https://api.urhja.com"; // previous
// export const baseURL = "http://datalumio.us-west-2.elasticbeanstalk.com/"; // old EB

// Subscription keys (keep as-is)
export const proMonthlyLookupKey = "lumio-pro-monthly";
export const proYearlyLookupKey = "lumio-pro-yearly";
export const starterMonthlyLookupKey = "lumio-starter";
export const starterYearlyLookupKey = "lumio-starter";

// Axios instance using the dynamic baseURL
const Repository = axios.create({
  baseURL, // ← now automatically uses live or test
  headers: {
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
  },

});
export default Repository;
